import { createContext, useContext } from 'react';

type NestedFilterSelectContextValue = {
  selectedValue: string | null;
  onSelectValue: (value: string) => void;
};

export const NestedFilterSelectContext =
  createContext<NestedFilterSelectContextValue | null>(null);

export function useNestedFilterSelectContext(): NestedFilterSelectContextValue {
  const ctx = useContext(NestedFilterSelectContext);
  if (ctx === null) {
    throw new Error(
      'NestedFilterSelect.Item must be rendered inside <NestedFilterSelect>'
    );
  }
  return ctx;
}
